import { Image, Upload, message, Tooltip } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const ThumbnailGrid = ({ items = [], albumKey, onUpload }) => {
  const handleBeforeUpload = async (file) => {
    try {
      await onUpload(file, albumKey);
      message.success("Upload berhasil!");
    } catch (err) {
      console.error(err);
      message.error("Upload gagal.");
    }
    return false; // prevent default auto upload
  };

  const forceDownload = (url, filename) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename || "download");
  document.body.appendChild(link);
  link.click();
  link.remove();
};


  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {items.map((item, idx) => {
        const isPDF = item.value?.toLowerCase().endsWith(".pdf");

        return (
          <div key={idx} className="flex flex-col items-center">
            <div className="w-full aspect-square bg-white border rounded overflow-hidden shadow flex items-center justify-center hover:shadow-md transition">
              {isPDF ? (
                <a
                  href={item.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-col items-center justify-center text-red-600 hover:text-red-500"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg"
                    alt="PDF Preview"
                    className="w-16 h-16 mb-1"
                  />
                  <span className="text-xs text-center font-semibold">
                    Lihat PDF
                  </span>
                </a>
              ) : (
                <div className="relative w-full h-full">
                  <Image
                    src={item.value}
                    alt={item.label}
                    className="w-full h-full object-cover"
                    // preview={{
                    //   mask: (
                    //     <span style={{ color: "#fff", fontSize: 12 }}>
                    //       Klik untuk preview
                    //     </span>
                    //   ),
                    // }}
                  />
                  {/* <a
                    href={item.value}
                    download
                    className="absolute top-1 right-1 bg-white/80 text-xs text-blue-700 px-2 py-1 rounded shadow hover:bg-white transition"
                  >
                    Download
                  </a> */}
                </div>
              )}
            </div>
            <p className="mt-1 text-xs text-center text-gray-700 px-1">
              {item.label}
            </p>
          </div>
        );
      })}

      
    </div>
  );
};

const getLabelFromKey = (key) => {
  switch (key) {
    case "docpekerjaanimage":
      return "Dok Pekerjaan";
    case "docsimulasiimage":
      return "Dok Simulasi";
    case "doctambahanimage":
      return "Dok Tambahan";
    default:
      return "Dokumen";
  }
};

export default ThumbnailGrid;
